<template>
  <!-- Attendance Report -->
  <div class="modal fade" id="attendance_report">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Attendance</h4>
          <button
            type="button"
            class="btn-close custom-btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ti ti-x"></i>
          </button>
        </div>

        <div class="modal-body">
          <div class="card shadow-none bg-transparent-light">
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-sm-3">
                  <div class="mb-3">
                    <span>Date</span>
                    <p class="text-gray-9 fw-medium">{{ dateLabel }}</p>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="mb-3">
                    <span>Clocked in at</span>
                    <p class="text-gray-9 fw-medium">{{ inLabel }}</p>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="mb-3">
                    <span>Clocked out at</span>
                    <p class="text-gray-9 fw-medium">{{ outLabel }}</p>
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="mb-3">
                    <span>Status</span>
                    <p class="text-gray-9 fw-medium">{{ r?.status || "-" }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card shadow-none border mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i
                        class="ti ti-point-filled text-dark-transparent me-1"
                      ></i
                      >Total Working hours
                    </p>
                    <h3>{{ totalLabel }}</h3>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i class="ti ti-point-filled text-success me-1"></i
                      >Productive Hours
                    </p>
                    <h3>{{ prodLabel }}</h3>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i class="ti ti-point-filled text-warning me-1"></i>Break
                      hours
                    </p>
                    <h3>{{ breakLabel }}</h3>
                  </div>
                </div>
                <div class="col-xl-3">
                  <div class="mb-4">
                    <p class="d-flex align-items-center mb-1">
                      <i class="ti ti-point-filled text-info me-1"></i>Overtime
                    </p>
                    <h3>{{ otLabel }}</h3>
                  </div>
                </div>
              </div>

              <!-- Decorative bar (kept simple) -->
              <div class="row">
                <div class="col-md-8 mx-auto">
                  <div
                    class="progress bg-transparent-dark mb-3"
                    style="height: 24px"
                  >
                    <div
                      class="progress-bar bg-success rounded me-2"
                      role="progressbar"
                      style="width: 40%"
                    ></div>
                    <div
                      class="progress-bar bg-warning rounded me-2"
                      role="progressbar"
                      style="width: 10%"
                    ></div>
                    <div
                      class="progress-bar bg-info rounded"
                      role="progressbar"
                      style="width: 5%"
                    ></div>
                  </div>
                </div>
                <div class="co-md-12">
                  <div
                    class="d-flex align-items-center justify-content-between"
                  >
                    <span class="fs-10">06:00</span>
                    <span class="fs-10">08:00</span>
                    <span class="fs-10">10:00</span>
                    <span class="fs-10">12:00</span>
                    <span class="fs-10">14:00</span>
                    <span class="fs-10">16:00</span>
                    <span class="fs-10">18:00</span>
                  </div>
                </div>
              </div>
              <!-- /decorative bar -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Attendance Report -->
</template>

<script setup>
import { computed } from "vue";
import { useAttendanceEmployeeStore } from "@/stores/attendanceEmployeeStore";

const store = useAttendanceEmployeeStore();

const r = computed(() => store.state.todayRecord);

const dateLabel = computed(() => {
  if (!r.value?.work_date) return "-";
  try {
    return new Date(r.value.work_date).toLocaleDateString();
  } catch {
    return r.value.work_date;
  }
});
const inLabel = computed(() => {
  if (!r.value?.check_in_at) return "-";
  try {
    return new Date(r.value.check_in_at).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return r.value.check_in_at;
  }
});
const outLabel = computed(() => {
  if (!r.value?.check_out_at) return "-";
  try {
    return new Date(r.value.check_out_at).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return r.value.check_out_at;
  }
});
const totalLabel = computed(() => {
  const m = r.value?.total_work_minutes || 0;
  const h = Math.floor(m / 60),
    mm = m % 60;
  return `${h}h ${String(mm).padStart(2, "0")}m`;
});
const prodLabel = computed(() => {
  const m = r.value?.productive_minutes || r.value?.total_work_minutes || 0;
  const h = Math.floor(m / 60),
    mm = m % 60;
  return `${h}h ${String(mm).padStart(2, "0")}m`;
});
const breakLabel = computed(() => `${r.value?.break_minutes || 0}m`);
const otLabel = computed(() => {
  const m = r.value?.overtime_minutes || 0;
  const h = Math.floor(m / 60),
    mm = m % 60;
  return `${h}h ${String(mm).padStart(2, "0")}m`;
});
</script>
